import * as Yup from 'yup';
import { TFunction } from 'react-i18next';
import { BaseSchema } from 'yup';

import './_yup.extensions';

import { isPostalCodeValid } from 'services/validation';
import {
  FIELD_COUNTRY_MAX_FR,
  FIELD_COUNTRY_MAX_UK,
} from 'settings/constraints';
import {
  FIRSTNAME_REGEX,
  LANDLINE_FR_REGEX,
  LANDLINE_UK_REGEX,
  LASTNAME_REGEX,
  ORDER_NUMBER_REGEX,
  POSTCODE_UK_REGEX,
} from 'settings/regex';

export default (isUk: boolean, t: TFunction): BaseSchema =>
  Yup.object().shape({
    civility: Yup.string().required(t('LABEL_ERROR_TITLE_REQUIRED')),
    lastName: Yup.string()
      .required(t('LABEL_ERROR_SURNAME_REQUIRED'))
      .min(2, t('LABEL_ERROR_SURNAME_MAX', { ns: 'translation' }))
      .max(isUk ? 32 : 38, t('LABEL_ERROR_SURNAME_MAX', { ns: 'translation' }))
      .matches(LASTNAME_REGEX, t('LABEL_ERROR_SURNAME_MUST_LETTERS')),
    firstName: Yup.string()
      .required(t('LABEL_ERROR_FIRST_NAME_REQUIRED'))
      .min(2, t('LABEL_ERROR_FIRST_NAME_MAX', { ns: 'translation' }))
      .max(
        isUk ? 32 : 38,
        t('LABEL_ERROR_FIRST_NAME_MAX', { ns: 'translation' })
      )
      .matches(FIRSTNAME_REGEX, t('LABEL_ERROR_FIRST_NAME_MUST_LETTERS')),
    email: Yup.string()
      .required(t('LABEL_ERROR_EMAIL_REQUIRED'))
      .email(t('LABEL_ERROR_INVALID_EMAIL'))
      .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC', { ns: 'translation' })),
    nameWay: Yup.string()
      .required(t('LABEL_ERROR_NAME_WAY_REQUIRED'))
      .min(2, t('LABEL_ERROR_NAME_WAY_LENGTH', { ns: 'translation' }))
      .max(
        isUk ? 32 : 38,
        t('LABEL_ERROR_NAME_WAY_LENGTH', { ns: 'translation' })
      )
      .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC', { ns: 'translation' })),
    nameComplement: Yup.string()
      .min(2, t('LABEL_ERROR_NAME_COMPLEMENT_LENGTH', { ns: 'translation' }))
      .max(
        isUk ? 32 : 38,
        t('LABEL_ERROR_NAME_COMPLEMENT_LENGTH', { ns: 'translation' })
      )
      .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC', { ns: 'translation' })),
    nameAddress: Yup.string()
      .min(2, t('LABEL_ERROR_NAME_ADDRESS_LENGTH', { ns: 'translation' }))
      .max(
        isUk ? 32 : 38,
        t('LABEL_ERROR_NAME_ADDRESS_LENGTH', { ns: 'translation' })
      )
      .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC', { ns: 'translation' })),
    locality: Yup.string()
      .min(2, t('LABEL_ERROR_NAME_SAID_PLACE_LENGTH', { ns: 'translation' }))
      .max(
        isUk ? 32 : 38,
        t('LABEL_ERROR_NAME_SAID_PLACE_LENGTH', { ns: 'translation' })
      )
      .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC', { ns: 'translation' })),
    postCode: Yup.string()
      .required(t('LABEL_ERROR_POSTCODE_REQUIRED'))
      .min(isUk ? 6 : 5, t('LABEL_ERROR_POSTCODE_LENGTH'))
      .max(isUk ? 8 : 5, t('LABEL_ERROR_POSTCODE_LENGTH'))
      .test('postcode', t('LABEL_ERROR_POSTCODE_REGEX'), function (value) {
        return !value
          ? true
          : isUk
          ? POSTCODE_UK_REGEX.test(value)
          : isPostalCodeValid(value);
      }),
    city: Yup.string()
      .required(t('LABEL_ERROR_CITY_REQUIRED'))
      .max(
        isUk ? FIELD_COUNTRY_MAX_UK : FIELD_COUNTRY_MAX_FR,
        t('LABEL_ERROR_CITY_MAX', { ns: 'translation' })
      )
      .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC', { ns: 'translation' })),
    country: Yup.string()
      .required(t('LABEL_ERROR_COUNTRY_REQUIRED'))
      .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC', { ns: 'translation' })),
    landLine: Yup.string().matches(
      isUk ? LANDLINE_UK_REGEX : LANDLINE_FR_REGEX,
      t('LABEL_ERROR_PHONE_NUMBER_REGEX', { ns: 'translation' })
    ),
    orderNumber: Yup.string().matches(
      ORDER_NUMBER_REGEX,
      t('LABEL_ERROR_ORDER_NUMBER')
    ),
    subject: Yup.string()
      .required(t('LABEL_ERROR_SUBJECT_REQUIRED'))
      .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC', { ns: 'translation' })),
    message: Yup.string()
      .required(t('LABEL_ERROR_MESSAGE_REQUIRED'))
      .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC', { ns: 'translation' })),
    turnstileToken: Yup.string().turnstileRequired(
      t('FORM_TURNSTILE_REQUIRED_ERROR', { ns: 'translation' })
    ),
  });
